import { render, staticRenderFns } from "./VCardEvents.vue?vue&type=template&id=21354486&scoped=true"
import script from "./VCardEvents.vue?vue&type=script&lang=js"
export * from "./VCardEvents.vue?vue&type=script&lang=js"
import style0 from "./VCardEvents.vue?vue&type=style&index=0&id=21354486&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21354486",
  null
  
)

export default component.exports